/**
 * userpool.js - Amazon Cognito User Pool Configuration
 *
 * This file configures the Amazon Cognito User Pool, which is used for user authentication
 * and management. It sets up the connection between the application and AWS Cognito service.
 *
 * Key Features:
 * - Configures AWS Cognito User Pool
 * - Manages user authentication with AWS
 * - Uses environment variables for secure configuration
 *
 * @module userpool
 */

import { CognitoUserPool } from "amazon-cognito-identity-js";

// Configuration object for the Cognito User Pool
// Uses environment variables for security
const poolData = {
  UserPoolId: process.env.REACT_APP_USER_POOL_ID, // AWS Cognito User Pool ID
  ClientId: process.env.REACT_APP_CLIENT_ID, // AWS Cognito App Client ID
};

// Create and export a new instance of CognitoUserPool
export default new CognitoUserPool(poolData);
